/**
 * Compares two strings ignoring leading and trailing whitespaces,
 * safely normalizing undefined/null into empty string.
 */
export const equalsIgnoringWhitespace = (str1: string, str2: string): boolean =>
  (str1?.trim() ?? '') === (str2?.trim() ?? '');

export const replaceAll = (stringInput: string, search: string, replace:string): string => 
  (stringInput?.split(search)?.join(replace));
